//
//Function:landing page for performance report
//
//
//To get execution report
//
//details and
//
//system performance data
//
//
//from the
//
//performance report
//
// import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import VirtualizedSelect from 'react-virtualized-select';
import ExecutionReportDetails from './executionReportDetails';
import Visualization from './visualization';
import { getFilterDataForReport, getExecutionReportDetails, getSystemPerformanceData, getSystemPerformanceDataCSV } from './../../UserFunctions';
import { fetchPerformanceDetails } from './../../../actions/closeLoop/performanceDashboard/performanceDashboardActions';
import Loader from './../../../utilityComponents/Loader';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Message from './../../../utilityComponents/Message';
import { Button } from 'react-bootstrap';
import React, { Component } from 'react';

class PerformanceReport extends Component {
    constructor(props) {
        super(props)
        //
        // default value initialization
        //
        //this.state parameters
        //
        this.state = {
            usingQueryParams: false,
            executionReportInfo: {},
            systemPerformanceInfo: {},
            tagName: '',
            scenarioGroup: '',
            benchName: '',
            testRunId: '',
            apiData: {
                filterData: [],
                tagNames: [],
                scenarioGroups: [],
                benchNames: [],
                testRunIds: []
            },
            systemPerformancecsv: []
        }
    }

    //
    //Function called after component is mounted
    //
    componentDidMount() {
        const { testRun } = this.props.match.params;
        if (testRun === undefined) {
            //
            //function to get filter data for report
            //
            getFilterDataForReport().then((response) => {
                if (response && response.status === 200) {
                    const tagNames = response['data']['tag_names'];
                    const uniqueTagNames = [...new Set(tagNames)];
                    const organizedTags = uniqueTagNames.map((item, index) => {
                        return {
                            label: item,
                            value: index
                        }
                    })
                    //
                    //setState function
                    //
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            apiData: {
                                filterData: response['data']['records'],
                                tagNames: organizedTags,
                                scenarioGroups: [],
                                benchNames: [],
                                testRunIds: []
                            }
                        }
                    })
                }
            })
        } else {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    usingQueryParams: true
                }
            });

            const payload = {
                test_run_id: testRun

            }
            console.log(payload)

            //
            // Function to get the execution report details
            //
            getExecutionReportDetails(payload).then((response) => {
                if (response && response.status === 200) {
                    if (response.data['message'] === 'fetched_execution_report_details') {
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                executionReportInfo: response.data['execution_report']
                            }
                        })
                    } else {
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                executionReportInfo: {}
                            }
                        })
                    }
                }
            });


            // Function to get system performance data

            getSystemPerformanceData(payload).then((response) => {
                if (response && response.status === 200) {
                    if (response.data['message'] === 'fetched_system_performance_data') {
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                systemPerformanceInfo: response.data['gpu_performance']
                            }
                        })
                    } else {
                        this.setState((prevState) => {
                            return {
                                ...prevState,
                                systemPerformanceInfo: {}
                            }
                        })
                    }
                }
            })
        }
    }

    //Function when tag name changes

    onTagNameChange = (tagName) => {
        const { filterData, tagNames } = this.state.apiData;
        const scenarioGroups = filterData.filter((item) => {
            return item['tag_name'] === tagName.label
        }).map((item) => item['bench_configuration']['scenario_group_id']);
        const uniqueScenarioGroups = [...new Set(scenarioGroups)];
        this.setState((prevState) => {
            return {
                ...prevState,
                tagName,
                apiData: {
                    filterData,
                    tagNames,
                    scenarioGroups: uniqueScenarioGroups.map((item, index) => {
                        return {
                            label: item,
                            value: index
                        }
                    }),
                    benchNames: [],
                    testRunIds: []
                }
            }
        });
    }
    //
    //Function when scenario group changes
    //
    //
    onScenarioGroupChange = (scenarioGroup) => {
        const { filterData, tagNames, scenarioGroups } = this.state.apiData;
        const benchNames = filterData.filter((item) => {
            return item['tag_name'] === this.state.tagName.label && 
            item['bench_configuration']['scenario_group_id'] === scenarioGroup.label
        }).map((item) => item['bench_name']);
        const uniqueBenchNames = [...new Set(benchNames)];
        this.setState((prevState) => {
            return {
                ...prevState,
                scenarioGroup,
                apiData: {
                    filterData,
                    tagNames,
                    scenarioGroups,
                    benchNames: uniqueBenchNames.map((item, index) => {
                        return {
                            label: item,
                            value: index
                        }
                    }),
                    testRunIds: []
                }
            }
        })
    }
    //
    //Function when bench name changes
    //
    onBenchNameChange = (benchName) => {
        const { filterData, tagNames, scenarioGroups, benchNames } = this.state.apiData;
        const testRunIds = filterData.filter((item) => {
            return item['tag_name'] === this.state.tagName.label &&
                item['bench_configuration']['scenario_group_id'] === this.state.scenarioGroup.label && item['bench_name'] === benchName.label
        })

        const uniqueTestRunIds = [...new Set(testRunIds)];

        this.setState((prevState) => {
            return {
                ...prevState,
                benchName,
                apiData: {
                    filterData,
                    tagNames,
                    scenarioGroups,
                    benchNames,
                    testRunIds: uniqueTestRunIds.map((item, index) => {
                        return {
                            label: item['test_run_id'],
                            value: index
                        }
                    })
                }
            }
        })
    }
    //
    //Function when test run ID changes
    //
    onTestRunIdChange = (testRunId) => {
        const { filterData, tagNames, scenarioGroups, benchNames, testRunIds } = this.state.apiData;

        const payload = {
            bench_name: this.state.benchName.label,
            test_run_id: testRunId.label,
            chart_name: 'gpu_utilization'
        }

        getExecutionReportDetails(payload).then((response) => {
            console.log(payload)
            if (response && response.status === 200) {
                if (response.data['message'] === 'fetched_execution_report_details') {
                    console.log("!!!!!!!!!!!!!!!!!!!!!!!!@@@@@@@@@@@@@@@@@@@@@@");
                    console.log(response.data['execution_report'])
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            executionReportInfo: response.data['execution_report']
                        }
                    })
                    this.props.fetchExecutionDetails(payload);
                } else {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            executionReportInfo: {}
                        }
                    })
                }
            }
        });



        this.setState((prevState) => {
            return {
                ...prevState,
                testRunId,
                apiData: {
                    filterData,
                    tagNames,
                    scenarioGroups,
                    benchNames,
                    testRunIds
                }
            }
        })
    }

    onTestRunIdChangeCSV = () => {
        const payload = {
            bench_name: this.state.benchName.label,
            test_run_id: this.state.testRunId.label
        }
        getSystemPerformanceDataCSV(payload).then((response) => {
            if (response && response.status === 200) {
                //const fileName = response.headers["content-disposition"].split("filename=")[1];
                const url = window.URL.createObjectURL(
                    new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',
                    response.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }

        }).catch((error) => {
            console.log(error);
        })
    }

    render() {
        console.log(this.props);
        return (
            <div data-test='closedLoopPerformanceReportLandingComponent' className='container-fluid'>
                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        <Link to='/welcome'>Welcome</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""  >
                        <Link to='/close_loop'>Close loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/close_loop/performance_report" active >
                        Performance Report
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className='row' style={{ paddingTop: '4%' }}>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                <div className='row align-items-center'>
                                    <div className='col-10'>
                                        <h2>Performance Report</h2>
                                    </div>
                                    <div className='col-2'>
                                        <Link to='/close_loop/cad/tag_names'>
                                            <button className='btn' style={{ backgroundColor: "#FFFFFF", color: "#757AF7" }}>Tag Names</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body'>
                                {!this.state.usingQueryParams ?
                                    <div className='row'>
                                        <div className='col-3'>
                                            <div className='card'>
                                                <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                    <div className='row'>
                                                        <div className='col-12 align-self-center'>
                                                            <h5>Version Tag</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-body'>
                                                    <VirtualizedSelect
                                                        options={this.state.apiData.tagNames}
                                                        onChange={(tagName) => { this.onTagNameChange(tagName) }}
                                                        value={this.state.tagName}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.apiData.scenarioGroups.length > 0 ?
                                            <div className='col-3'>
                                                <div className='card'>
                                                    <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                        <div className='row'>
                                                            <div className='col-12 align-self-center'>
                                                                <h5>Scenario Group</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-body'>
                                                        <VirtualizedSelect
                                                            options={this.state.apiData.scenarioGroups}
                                                            onChange={(scenarioGroup) => { this.onScenarioGroupChange(scenarioGroup) }}
                                                            value={this.state.scenarioGroup}
                                                        />
                                                    </div>
                                                </div>
                                            </div> :
                                            undefined}
                                        {this.state.apiData.benchNames.length > 0 ?
                                            <div className='col-3'>
                                                <div className='card'>
                                                    <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                        <div className='row'>
                                                            <div className='col-12 align-self-center'>
                                                                <h5>Bench Name</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-body'>
                                                        <VirtualizedSelect
                                                            options={this.state.apiData.benchNames}
                                                            onChange={(benchName) => { this.onBenchNameChange(benchName) }}
                                                            value={this.state.benchName}
                                                        />
                                                    </div>
                                                </div>
                                            </div> :
                                            undefined}
                                        {this.state.apiData.testRunIds.length > 0 ?
                                            <div className='col-3'>
                                                <div className='card'>
                                                    <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                        <div className='row'>
                                                            <div className='col-12 align-self-center'>
                                                                <h5>Run Id</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-body'>
                                                        <VirtualizedSelect
                                                            options={this.state.apiData.testRunIds}
                                                            onChange={(testRunId) => { this.onTestRunIdChange(testRunId) }}
                                                            value={this.state.testRunId}
                                                        />
                                                    </div>
                                                </div>
                                            </div> :
                                            undefined}
                                    </div> :
                                    undefined}
                                <div className='row' style={{ paddingTop: "2%" }}>
                                    <div className='col-12'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <h4>Execution Details</h4>
                                            </div>
                                            <div className='card-body'>
                                                {(this.props.benchName !== '' && this.props.testRunId !== '') ?
                                                    <ExecutionReportDetails
                                                        executionInfo={this.state.executionReportInfo}
                                                    /> :
                                                    undefined}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row' style={{ paddingTop: "2%" }}>
                                    <div className='col-12'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <div className='row align-items-center'>
                                                    <div className='col-10'>
                                                        <h4> System Performance</h4>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            type='submit'
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                color: '#757AF7'
                                                            }}
                                                            onClick={() => this.onTestRunIdChangeCSV()}
                                                            data-test="clickComponent"
                                                        >
                                                            Export CSV
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                {this.props.loading ?
                                                    <Loader /> : this.props.error ?
                                                        (
                                                            <Message variant={'danger'}>
                                                                {this.props.error}
                                                            </Message>
                                                        ) : (
                                                            <Visualization
                                                                testRunId={this.state.testRunId.label}
                                                                benchName={this.state.benchName.label}
                                                                gpuUtilizationXAxis={this.props.info.xAxis}
                                                                gpuUtilizationYAxis={this.props.info.yAxis}
                                                                systemPerformanceInfo={this.state.systemPerformanceInfo}
                                                            />)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
//
//setting performance report prop types
//
// PerformanceReport.propTypes={
// benchName:PropTypes.string,
// testRunId:PropTypes.string,
// match:PropTypes.string,
// //items:PropTypes.string,
// }
// //
// //setting performance report default props
// //
// PerformanceReport.defaultProps= {
// benchName:[],
// testRunId:[],
// match:[],
// //items:[],
// }

const mapStateToProps = (state) => ({
    loading: state.gpuUtilize.gpuUtilization.loading,
    info: state.gpuUtilize.gpuUtilization,
    error: state.gpuUtilize.gpuUtilization.error
})

const mapDispatchToProps = (dispatch) => ({
    fetchExecutionDetails: (payload) => dispatch(fetchPerformanceDetails(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceReport);